import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import CustomerAuthFormFields from './CustomerAuthFormFields'

const initialValues = { customerId: '', customerCode: '' }

const validationSchema = Yup.object().shape({
  customerId: Yup.string().required('Required'),
  customerCode: Yup.string().required('Required')
})

const CustomerAuthForm = ({ submitCustomerInfo }) => (
  <Formik
    initialValues={initialValues}
    onSubmit={submitCustomerInfo}
    validationSchema={validationSchema}
  >
    {props => <CustomerAuthFormFields {...props} />}
  </Formik>
)

export default CustomerAuthForm
